import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '3rem',
    maxHeight: '25rem',
    overflow: 'auto',
  },
}));

export default useStyles;
